import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { processesWidgets } from "@widgets/registry";
import PageLayout from "./PageLayout/PageLayout";
const ProcessesPage = () => {
    const { t } = useTranslation();
    return (_jsx(PageLayout, { title: t("pages.processes.title"), description: t("pages.processes.description"), widgets: processesWidgets }));
};
export default ProcessesPage;
